import { Text } from '@hub/text'
import { HubStyleObject } from '@hub/design-system-base'
import React from 'react'

const pagination = (page: number, limit: number, total: number): string => {
  const start = page * limit + 1
  const end = Math.min((page + 1) * limit, total)
  return total === 0 ? '0' : `${start} – ${end} of ${total}`
}

export interface PaginationSummaryProps {
  total: number
  limit: number
  page: number
  suffix?: string
  sx?: HubStyleObject
}

export const PaginationSummary: React.FC<PaginationSummaryProps> = ({
  total,
  limit,
  page,
  suffix,
  sx,
}) => (
  <Text sx={sx} isBodyText>
    {pagination(page, limit, total)}
    {suffix}
  </Text>
)
